<template>
  <div>
    <media-widget
      :value="content"
      @update="handleUpdate"
    />
  </div>
</template>

<script>
  import MediaWidget from '../../MediaWidget';

  export default {
    props: ['id', 'field'],

    components: {
      MediaWidget,
    },

    data() {
      return {
        content: this.field.value,
      };
    },

    methods: {
      handleUpdate(ids) {
        this.$emit('field-update', this.field.key, ids.join(','));
      },
    },
  };
</script>
